import { createFileRoute } from '@tanstack/react-router';

import { RzisView } from '../../raporty/rzis/RzisView';

export const Route = createFileRoute('/raporty/rzis')({
  component: RzisView,
});
